import React from 'react';
import { useParams, useNavigate } from 'react-router';
import { EditEventForm } from '@/components/org/EditEventForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function OrgEventEdit() {
  const { eventId, orgId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="mx-auto">
      <EditEventForm
        eventId={eventId}
        orgId={orgId}
        eventUpdated={() => navigate(`/app/org/${orgId}/event/${eventId}`)}
        onCancel={() => navigate(`/app/org/${orgId}/event/${eventId}`)}
      />
    </div>
  );
}
